"use strict";
Object.defineProperty(exports, "__esModule", {
  value: true
});
const tokens = {};
tokens._getCss = function () {return `/* imported from hideBs.css */ #__bs_notify__ { display: none!important; } `;};
tokens._module = (typeof module !== "undefined") ? module : {id:"./common/components/Artwork/hideBs_css.js"};
exports["default"] = tokens;